module.exports = new __parcel__URL__("step_one_vector_light.3d6a68ba.png").toString();